import React from 'react'
import "./slideButton.css"
const SlideButton = ({ slideActive, setSelected, slide , mainWrapper}) => {
  const handleSlide = () => {
    setSelected(slide.index)
    if(slide.index === 1){
      mainWrapper.current.style.transform = "translateY(-8px)"
    }
    else if(slide.index=== 2){
      mainWrapper.current.style.transform = "translateY(-163px)"
      
    }
    else if(slide.index === 3){
      mainWrapper.current.style.transform = "translateY(-318px)"
    }
    else if(slide.index === 4){
      mainWrapper.current.style.transform = "translateY(-470px)"
    }
    else if(slide.index === 5){
      mainWrapper.current.style.transform = "translateY(-627px)"
    }
    else{
      mainWrapper.current.style.transform = "translateY(-8px)"
    }
  }
  return (
    <div className={slideActive ? "slide-btn slideActive" : "slide-btn"}
        onClick={handleSlide}
    ></div>
  )
}

export default SlideButton